export default {
  domain: 'E',
  title: 'Extraversion',
  shortDescription: 'Extraversion beschreibt das ausgeprägte Engagement mit der Außenwelt.',
  description: `Extrovertierte lieben die Gesellschaft anderer Leute, 
sind voller Energie, und empfinden oft positive Gefühle. Sie sind 
enthusiastische, handlungsorientierte Individuen, die dazu neigen mit 
"Ja!" oder "Auf geht's" auf neue Chancen für aufregende Aktivitäten zu antworten.
In Gruppen reden sie gerne, setzen sich durch und ziehen die 
Aufmerksamkeit auf sich.
<br /><br />
Introvertierten fehlt die Ausgelassenheit, die Energie, und die Lust auf 
Aktivitäten des Extrovertierten. Sie tendieren dazu leise, 
zurückhaltend, wohlüberlegt, und von der sozialen Welt losgelöst zu 
sein. Ihr Mangel an sozialer Beteiligung sollte nicht als Schüchternheit 
oder Depression interpretiert werden; die Introvertierten brauchen 
lediglich weniger Stimulation als ein Extrovertierter und sind gerne 
allein.<br /><br />Die Unabhängigkeit und die zurückhaltende Weise eines 
Introvertierten wird manchmal als Unfreundlichkeit oder Arroganz 
misverstanden. In Wirklichkeit wird ein Introvertierter mit hoher 
Verträglichkeit nicht auf Menschen zugehen, ist aber ein geselliger Typ 
wenn sie/er von anderen angesprochen wird.`,
  results: [
    {
      score: 'low',
      text: `Deine Punktzahl in Extraversion ist niedrig, was darauf 
hinweist, dass du introvertiert, zurückhaltend und leise bist. Du magst 
die Einsamkeit und Aktivitäten die du alleine machen kannst. Deine 
sozialen Aktivitäten beschränken sich auf wenige, aber nahe Freunde.`
    },
    {
      score: 'neutral',
      text: `Deine Punktzahl in Extraversion ist mittelmäßig, was darauf 
hinweist, dass du weder ein leiser Einzelgänger noch eine heitere 
Labertasche bist. Dir gefällt es Zeit mit anderen als auch mit dir 
selbst zu verbringen.`
    },
    {
      score: 'high',
      text: `Deine Punktzahl in Extraversion ist hoch, was eine 
gesellige, extrovertierte, energetische und lebendige Art hinweist. Du 
ziehst es vor so viel Zeit wie möglich mit anderen Leuten zu 
verbringen.`
    }
  ],
  facets: [
    {
      facet: 1,
      title: 'Freundlichkeit',
      text: `Freundliche Menschen zeigen aufrichtige positive Gefühle 
gegenüber anderen Leuten. Sie finden schnell Freunde und es fällt ihnen 
leicht enge, intime Beziehungen zu knüpfen. Menschen mit niedriger 
Punktzahl in Freundlichkeit sind nicht unbedingt kalt und feindselig, 
aber sie neigen dazu nicht auf Leute zuzugehen und werden von anderen 
als distanziert und zurückhaltend angesehen.`
    },
    {
      facet: 2,
      title: 'Geselligkeit',
      text: `Gesellige Menschen empfinden die Gesellschaft anderer Leute 
als positive Stimulation und belohnend. Sie genießen eine Aufregung für 
Menschenmengen. Menschen mit niedrigen Punkten in Geselligkeit sind 
leicht von Menschenmassen überfordert und meiden diese oft. Sie hassen 
die Gesellschaft anderer Menschen nicht, aber ihr Bedürfnis nach 
Privatsphäre und Zeit für sich selbst ist viel größer als das der Leute, 
die eine hohe Punktzahl in dieser Skala haben.`
    },
    {
      facet: 3,
      title: 'Durchsetzungsvermögen',
      text: `Menschen mit einer hohen Punktzahl in Durchsetzungsvermögen 
lieben es ihre Meinung zu sagen und das Kommando zu übernehmen. Sie 
tendieren dazu der Leiter in Gruppen zu sein. Menschen mit niedriger 
Punktzahl neigen dazu nicht viel zu reden und überlassen anderen das 
Kommando in Gruppenaktivitäten.`
    },
    {
      facet: 4,
      title: 'Tatendrang',
      text: `Aktive Individuen leben einen schnelles, beschäftigtes 
Leben. Sie sind energisch und nehmen an vielen Aktivitäten teil. 
Menschen mit einer niedrigen Punktzahl in dieser Skala führen ein 
langsameres und müßigeres, entspannteres Leben.`
    },
    {
      facet: 5,
      title: 'Risikobereitschaft',
      text: `Menschen mit hoher Punktzahl in dieser Skala sind 
ohne ein hohes Stimulationsniveau oft gelangweilt. Sie lieben grelle Lichter 
und das Gedränge der Massen. Sie gehen oft ein Risiko ein und suchen den 
Nervenkitzel. Menschen mit einer niedrigen Punktzahl sind oft von Lärm 
und Tumult überfordert und von Nervenkitzel abgeneigt.`
    },
    {
      facet: 6,
      title: 'Heiterkeit',
      text: `Diese Skala misst die positive Stimmung und die Gefühle, 
nicht die negativen Gefühle (diese sind Teil der Neurotizismus Domäne). 
Personen mit hoher Punktzahl auf dieser Skala empfinden typischerweise 
oft zahlreiche positive Gefühle, einschließlich von Glückseligkeit, 
Enthusiasmus, Optimismus und Freude. Menschen mit niedriger Punktzahl 
sind nicht so anfällig für diese energetische Munterkeit.`
    }
  ]
};
